import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import { GET_ADJUSTMENT_CATEGORIES } from "../services/get-adjustment-categories";
import { GET_ADJUSTMENT_REASON_CODES } from "../services/get-adjustment-reason-codes";
import { GET_ADJUSTMENT_CODE_STATUS } from "../services/get-adjustment-code_status";

import { GET_ADJUSTMENT_CODES } from "../services/get-adjustment-codes";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../../common_components/mdae-framework";

export const INSERT_NEW_ADJUSTMENT_CATEGORY_ROW =
  "INSERT_NEW_ADJUSTMENT_CATEGORY_ROW";
export const SET_ADJUSTMENT_CATEGPRY_ID = "SET_ADJUSTMENT_CATEGPRY_ID";
export const TOGGLE_MAP_CARC_CODE_POPUP = "TOGGLE_MAP_CARC_CODE_POPUP";
export const SET_SELECTED_CARC_CODES = "SET_SELECTED_CARC_CODES";
export const TOGGLE_UPLOAD_CUSTOM_CODES_POPUP =
  "TOGGLE_UPLOAD_CUSTOM_CODES_POPUP";
export const UPDATE_TEMP_CUSTOM_CODE_LIST = "UPDATE_TEMP_CUSTOM_CODE_LIST";
export const SET_INVALID_CUSTOM_CARC_LIST = "SET_INVALID_CUSTOM_CARC_LIST";
export const SET_CUSTOM_CARC_LIST = "SET_CUSTOM_CARC_LIST";
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
export const SET_CHECKBOX_VALUE = "SET_CHECKBOX_VALUE";
export const SET_PREVENTABLE_DENIAL_ERROR = "SET_PREVENTABLE_DENIAL_ERROR";

const initialState = {
  adjustmentCategoryList: [],
  adjustmentReasonCodesList: [],
  adjustmentCodeStatusList: [],
  adjustmentCategoryId: -1,
  adjustmentCodesList: [],
  isUploadCustomCARCPopupVisible: false,
  selectedCARCCodes: [],
  completlyOverwriteExistingMapping: false,
};

export default function(state = initialState, action) {
  let newState;
  switch (action.type) {
    case TOGGLE_MAP_CARC_CODE_POPUP:
    case TOGGLE_UPLOAD_CUSTOM_CODES_POPUP:
    case UPDATE_TEMP_CUSTOM_CODE_LIST:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_ADJUSTMENT_CATEGORIES)(action)) {
        return {
          ...state,
          adjustmentCategoryList: [],
        };
      }
      if (isAsyncComplete(GET_ADJUSTMENT_CATEGORIES)(action)) {
        const response = action.response;
        return {
          ...state,
          adjustmentCategoryList: response.adjustmentCategoryList,
        };
      }
      if (isAsyncOperation(GET_ADJUSTMENT_REASON_CODES)(action)) {
        return {
          ...state,
          adjustmentReasonCodesList: [],
        };
      }
      if (isAsyncComplete(GET_ADJUSTMENT_REASON_CODES)(action)) {
        const response = action.response;
        return {
          ...state,
          adjustmentReasonCodesList: response.adjustmentReasonCodesList,
        };
      }
      if (isAsyncOperation(GET_ADJUSTMENT_CODE_STATUS)(action)) {
        return {
          ...state,
          adjustmentCodeStatusList: [],
        };
      }
      if (isAsyncComplete(GET_ADJUSTMENT_CODE_STATUS)(action)) {
        const response = action.response;
        return {
          ...state,
          adjustmentCodeStatusList: response,
        };
      }
      if (isAsyncOperation(GET_ADJUSTMENT_CODES)(action)) {
        return {
          ...state,
          adjustmentCodesList: [],
        };
      }
      if (isAsyncComplete(GET_ADJUSTMENT_CODES)(action)) {
        const response = action.response;
        return {
          ...state,
          adjustmentCodesList: response.adjustmentCodesList,
        };
      }
      return state;
    case INSERT_NEW_ADJUSTMENT_CATEGORY_ROW:
      let selectedKeysIndex = state.adjustmentCategoryList.findIndex(
        (obj) =>
          obj.adjustmentCategoryDesc ===
          action.data.change.adjustmentCategoryDesc
      );
      return {
        ...state,
        adjustmentCategoryList:
          selectedKeysIndex > -1
            ? [
                ...state.adjustmentCategoryList.slice(0, selectedKeysIndex),
                {
                  ...state.adjustmentCategoryList[selectedKeysIndex],
                  adjustmentCategoryId: action.data.change.adjustmentCategoryId,
                  adjustmentCategoryCode:
                    action.data.change.adjustmentCategoryCode,
                  adjustmentCategoryDesc:
                    action.data.change.adjustmentCategoryDesc,
                  localCategory: action.data.change.localCategory,
                  codeCount: action.data.change.codeCount,
                },
                ...state.adjustmentCategoryList.slice(selectedKeysIndex + 1),
              ]
            : [...state.adjustmentCategoryList, action.data.change],
      };
    case SET_ADJUSTMENT_CATEGPRY_ID:
      return {
        ...state,
        adjustmentCategoryId: action.data.adjustmentCategoryId,
      };
    case SET_SELECTED_CARC_CODES:
      return {
        ...state,
        selectedCARCCodes: action.data.selectedCARCCodes,
      };
    case SET_ADJUSTMENT_CATEGPRY_ID:
      return {
        ...state,
        adjustmentCategoryId: action.data.adjustmentCategoryId,
      };
    case SET_INVALID_CUSTOM_CARC_LIST:
      return {
        ...state,
        invalidCustomCarcList: action.data.invalidCustomCarcList,
      };
    case SET_CUSTOM_CARC_LIST:
      return {
        ...state,
        customCARCList: action.data.finalCustomCARCList,
      };
    case SET_ERROR_MESSAGE:
      return {
        ...state,
        error: action.data.errorMessage,
      };
    case SET_CHECKBOX_VALUE:
      return {
        ...state,
        completlyOverwriteExistingMapping:
          action.data.completlyOverwriteExistingMapping,
      };
    case SET_PREVENTABLE_DENIAL_ERROR:
      let selectedKeyIndex = state.adjustmentReasonCodesList.findIndex(
        (obj) =>
          obj.adjustmentReasonCode === action.data.obj.adjustmentReasonCode
      );
      return {
        ...state,
        adjustmentReasonCodesList: [
          ...state.adjustmentReasonCodesList.slice(0, selectedKeyIndex),
          {
            ...state.adjustmentReasonCodesList[selectedKeyIndex],
            preventableError:
              action.data.obj.preventableError == "P" ? "NP" : "P",
          },
          ...state.adjustmentReasonCodesList.slice(selectedKeyIndex + 1),
        ],
      };

    default:
      return state;
  }
}
